// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage, type IntlShape } from 'react-intl';

import { addLicenses } from 'state/commands/licenseCommands';
import AddLicenseDialog from './AddLicenseDialog';
import {
  hideDialogPanel,
  showDialogPanel,
} from 'state/commands/dialogPanelCommands';
import localizedStrings from 'util/localizedStrings';
import { ADD_LICENSE_PANEL_ID, SET_ACCOUNT_PANEL_ID } from 'util/constants';

type Props = {
  activePanelId: ?string,
  addLicenses: typeof addLicenses,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
  showDialogPanel: typeof showDialogPanel,
};

export default class NoAccount extends Component<Props> {
  handleClickAddLicense: Function;
  handleClickSetExtensisAccount: Function;
  renderOption: Function;
  renderSupportLink: Function;

  constructor() {
    super();
    this.handleClickAddLicense = this.handleClickAddLicense.bind(this);
    this.handleClickSetExtensisAccount = this.handleClickSetExtensisAccount.bind(
      this
    );
    this.renderOption = this.renderOption.bind(this);
    this.renderSupportLink = this.renderSupportLink.bind(this);
  }

  handleClickAddLicense(e: any) {
    e && e.currentTarget && e.currentTarget.blur();
    this.props.showDialogPanel(ADD_LICENSE_PANEL_ID);
  }

  handleClickSetExtensisAccount(e: any) {
    e && e.currentTarget && e.currentTarget.blur();
    this.props.showDialogPanel(SET_ACCOUNT_PANEL_ID);
  }

  renderOption(
    title: any,
    buttonLabel: any,
    handleClick: Function,
    dataTestName: string
  ) {
    return (
      <div className="box">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="title is-4">
            <FormattedMessage {...title} />
          </div>
          {this.renderSupportLink()}
        </div>
        <div>
          <button
            className="button is-primary is-outlined"
            data-test-name={dataTestName}
            onClick={handleClick}
          >
            <span className="icon">
              <i className="fa fa-lg fa-plus-circle" />
            </span>
            <FormattedMessage {...buttonLabel} />
          </button>
        </div>
      </div>
    );
  }

  renderSupportLink() {
    const {
      intl: { formatMessage },
    } = this.props;

    return (
      <a
        href={formatMessage(localizedStrings.EXTENSIS_SUPPORT_URL)}
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fa fa-question-circle fa-2x has-text-primary licenseInfoIcon" />
      </a>
    );
  }
  render() {
    const {
      activePanelId,
      addLicenses,
      hideDialogPanel,
      showDialogPanel,
    } = this.props;

    return (
      <Fragment>
        <AddLicenseDialog
          activePanelId={activePanelId}
          addLicenses={addLicenses}
          hideDialogPanel={hideDialogPanel}
          showDialogPanel={showDialogPanel}
        />

        {this.renderOption(
          localizedStrings.LIC_ACTIVATE,
          localizedStrings.LIC_CLICK_TO_ACTIVATE,
          this.handleClickSetExtensisAccount,
          'activate-with-account'
        )}

        {this.renderOption(
          localizedStrings.LIC_TRIAL,
          localizedStrings.LIC_CLICK_TO_USE,
          this.handleClickAddLicense,
          'try-with-demo'
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/LicensesPage/NoAccount.js